<template>
    <div class="content">
        <div class="personal_info">
            <div class="personal_title">
                <p>个人信息</p>
                <img :src="require('@/assets/img/write.png')" alt="" @click="jump('/interviews/perinfo')">
            </div>
            <div class="personal_content">
                <div class="name">
                    <div class="name_left">
                        <span>{{resume.name}}</span>
                        <img v-if="resume.sex==1" :src="require('@/assets/img/nf.png')" alt="">
                        <img v-else :src="require('@/assets/img/nl.png')" alt="">
                    </div>
                    <img :src="resume.avatar_url" alt="">
                </div>
                <div class="content_info">
                    <div class="info_experience">
                        <div class="experience">
                            <img :src="require('@/assets/img/experience.png')" alt="">
                            <span class="plcspan">{{jobwanted.work_experience}}年经验</span>
                        </div>
                        <div class="edu">
                            <img :src="require('@/assets/img/edu.png')" alt="">
                            <span class="plcspan">{{edu[resume.education]}}学历</span>
                        </div>
                    </div>
                    <div class="info_age">
                        <div class="age">
                            <img :src="require('@/assets/img/age.png')" alt="">
                            <span class="plcspan">{{resume.birthday | calc}}岁<span class="dian">·</span>{{resume.marry_status==1?'已婚':'未婚'}}</span>
                        </div>
                        <div class="nation">
                            <img :src="require('@/assets/img/nation.png')" alt="">
                            <span class="plcspan">{{nation[resume.nation]}}<span class="dian">·</span>{{resume.census_address}}户口</span>
                        </div>
                    </div>
                    <div class="info_phone">
                        <div class="phone">
                            <img :src="require('@/assets/img/phone.png')" alt="">
                            <span class="plcspan">{{resume.telephone}}</span>
                        </div>
                        <div class="email">
                            <img :src="require('@/assets/img/email.png')" alt="">
                            <span class="plcspan">{{resume.email}}</span>
                        </div>
                    </div>
                    <div class="info_idcard">
                        <img :src="require('@/assets/img/idcard.png')" alt="">
                        <span class="plcspan">身份证: {{resume.idcard}}</span>
                    </div>
                    <div class="info_adress">
                        <img :src="require('@/assets/img/address.png')" alt="">
                        <span class="plcspan">现住址: {{resume.address}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="jobwanted_info">
            <div class="jobwanted_title">
                <p>求职信息</p>
                <img :src="require('@/assets/img/write.png')" alt="" @click="jump('/interviews/jobinfo')">
            </div>
            <div class="jobwanted_content">
                <p class="position">{{position[jobwanted.apply_position_id]}} {{salary[jobwanted.expect_salary_id]}}</p>
                <p class="work_status">{{jobwanted.work_status==1?'离职':'在职'}}-{{jobwanted.expect_date_char}}</p>
                <p class="referrer" v-if="jobwanted.referrer_name">推荐人：{{jobwanted.referrer_name}}</p>
            </div>
        </div>
        <div class="education_info">
            <div class="education_title">
                <p>教育经历</p>
                <img :src="require('@/assets/img/write.png')" alt="" @click="jump('/interviews/educationlist')">
            </div>
            <div class="education_content">
                <div class="education_item" v-for="(v,i) in education" :key="i">
                    <div class="education_top">
                        <span class="education_name">{{v.college_name}}</span>
                        <span class="education_time">{{v.start_date}}-{{v.end_date}}</span>
                    </div>
                    <div class="education_bottom">
                        <span class="education_college">{{v.education_name}}</span>
                        <span class="dian">·</span>
                        <span class="education_major">{{v.major_name}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="job_info">
            <div class="job_title">
                <p>工作经历</p>
                <img :src="require('@/assets/img/write.png')" alt="" @click="jump('/interviews/worklist')">
            </div>
            <div class="job_content">
                <div class="job_item" v-for="(v,i) in job" :key="i">
                    <div class="job_top">
                        <span class="job_name">{{v.company_name}}</span>
                        <span class="job_time">{{v.start_date}}-{{v.end_date}}</span>
                    </div>
                    <div class="job_bottom">
                        <span class="job_position">{{v.position_name}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="project_info">
            <div class="project_title">
                <p>项目经验</p>
                <img :src="require('@/assets/img/write.png')" alt="" @click="jump('/interviews/projectlist')">
            </div>
            <div class="project_content">
                <div class="project_item" v-for="(v,i) in project" :key="i">
                    <div class="project_item_title">
                        <div class="item_title_top">
                            <span class="project_name">{{v.project_name}}</span>
                            <span class="project_time">{{v.start_date}}-{{v.end_date}}</span>
                        </div>
                        <div class="item_title_bottom">
                            <span class="project_role">担任角色：{{v.role_name}}</span>
                        </div>
                    </div>
                    <div class="project_workresult">
                        <p class="workresult_text" v-show="v.work_result">
                            工作成果：{{v.work_result}}
                        </p>
                        <div class="workresult_image">
                            <div class="img_item">
                                <img v-for="(val,idx) in JSON.parse(v.show_images)" :key="idx" :src="val"/>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn_group">
            <van-button plain type="danger" @click="jump2('/interviews/perinfo')">修改</van-button>
            <van-button type="danger" @click="confirm">确认</van-button>
        </div>
        <load :loading="loading"></load>
    </div>
</template>

<script>
import { getResumeInfoApi,getNationApi,getEducationApi,getPositionApi,getSalaryApi,sendEmailApi } from '@/api/interview'
import Load from "@/components/Loading"
import { Toast } from 'vant';
    export default {
        data(){
            return {
                id: sessionStorage.getItem("ID"),
                resume:{},
                jobwanted:{},
                education:[],
                job:[],
                project:[],
                nation:{},
                edu:{},
                position:{},
                salary:{},
                loading:false,
            }
        },
        methods:{
            // 确认
            confirm(){
                sendEmailApi({id:this.id}).then(res=>{
                    if(res.errNo===0){
                        this.$router.push({path:"/interviews/hld"})
                    } else {
                        Toast(res.result);
                    }
                })
            },
            // 路由跳转
            jump(path){
                this.$router.push({path,query:{edit:1}})
            },
            // 路由跳转
            jump2(path){
                this.$router.push({path})
            },
            // 页面初始化获取数据
            async getData(){
                getNationApi().then(res=>{
                    if(res.errNo===0){
                        this.nation = res.result
                    }
                })
                getEducationApi().then(res=>{
                    if(res.errNo===0){
                        this.edu = res.result
                    }
                })
                getPositionApi().then(res=>{
                    if(res.errNo===0){
                        this.position = res.result
                    }
                })
                getSalaryApi().then(res=>{
                    if(res.errNo===0){
                        this.salary = res.result
                    }
                })
                getResumeInfoApi({id:this.id,audition:1}).then(res=>{
                    if(res.errNo===0){
                        this.resume = res.result.resume
                        this.jobwanted = res.result.apply_job
                        this.education = res.result.edu_experience
                        this.job = res.result.work_experience
                        this.project = res.result.project_experience
                        this.loading = false
                    }
                })
            }
        },
        filters:{
            calc(value){
                if(!value){
                    return
                }
                let date = new Date(value.replace(/-/g, "/"));
                let d = new Date();
                let result = d.getFullYear() - date.getFullYear() -(d.getMonth() < date.getMonth() || (d.getMonth() == date.getMonth() && d.getDate() < date.getDate()) ? 1: 0);
                return result
            }
        },
        created(){
            this.loading = true
            this.getData()
        },
        components: {
            Load
        }
    }
</script>

<style scoped lang="less">
.content {
    padding: 40px 17px 0 34px;
    .personal_info {
        .personal_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
                font-size: 34px;
                border-left: 6px solid #ee2e2e;
                padding-left: 10px;
                height: 36px;
                line-height: 32px;
            }
            img {
                width: 28px;
                height: 28px;
            }
        }
        .personal_content {
            padding-top: 50px;
            .name {
                display: flex;
                justify-content: space-between;
                align-items: center;                
                .name_left {
                    position: relative;
                    span {
                        font-size: 32px;
                        font-weight: 900;
                        margin-right: 18px;
                    }
                    img {
                        width: 26px;
                        height: 26px;
                        position: absolute;
                        top: 6px;
                    }
                }
                img {
                    width: 104px;
                    height: 104px;
                    border-radius: 50%;
                }
            }
        }
        .content_info {
            .info_experience{
                display: flex;
                .experience {
                    width: 254px;
                    img {
                        margin-right: 10px;
                        width: 26px;
                        height: 23px;
                    }
                }
                .edu {
                    img {
                        margin-right: 10px;
                        width: 28px;
                        height: 24px;
                    }
                }
            }
            .info_age {
                padding-top: 16px;
                display: flex;
                .age {
                    position: relative;
                    width: 254px;
                    img {
                        position: absolute;
                        top: 6px;
                        width: 23px;
                        height: 27px;
                    }
                    span {
                        padding-left: 33px;
                    }
                }
                .nation {
                    position: relative;
                    img {
                        position: absolute;
                        top: 4px;
                        width: 29px;
                        height: 29px;
                    }
                    span {
                        padding-left: 39px;
                    }
                }
            }
            .info_phone {
                padding-top: 16px;
                display: flex;
                .phone {
                    width: 254px;
                    position: relative;
                    img {
                        position: absolute;
                        top: 5px;
                        margin-right: 10px;
                        height: 26px;
                    }
                    span {
                        padding-left: 38px;
                    }
                }
                .email {
                    img {
                        margin-right: 10px;
                        width: 26px;
                        height: 20px;
                    }
                }
            }
            .info_idcard {
                padding-top: 16px;
                img {
                    margin-right: 10px;
                    width: 27px;
                    height: 20px;
                }
            }
            .info_adress {
                padding-top: 16px;
                position: relative;
                img {
                    position: absolute;
                    top: 20px;
                    width: 22px;
                    height: 27px;
                }
                span {
                    padding-left: 32px;
                }
            }
        }
    }
    .jobwanted_info {
        padding-top: 58px;
        .jobwanted_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
                font-size: 34px;
                border-left: 6px solid #ee2e2e;
                padding-left: 10px;
                height: 36px;
                line-height: 32px;
            }
            img {
                width: 28px;
                height: 28px;
            }
        }
        .jobwanted_content {
            padding: 40px 0 0 24px;
            font-size: 26px;
            .position {
                color: #333333;
            }
            .work_status {
                color: #7c7c7c;
                padding: 18px 0;
            }
            .referrer {
                color: #666666;
            }
        }
    }
    .education_info {
        padding-top: 58px;
        .education_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
                font-size: 34px;
                border-left: 6px solid #ee2e2e;
                padding-left: 10px;
                height: 36px;
                line-height: 32px;
            }
            img {
                width: 28px;
                height: 28px;
            }
        }
        .education_content {
            .education_item {
                padding-top: 54px;
                padding-left: 22px;
                .education_top {
                    display: flex;
                    justify-content: space-between;
                    .education_name {
                        color: #333333;
                        font-size: 26px;
                        font-weight: 600;
                    }
                    .education_time {
                        color: #b0b0b0;
                        font-size: 26px;
                    }
                }
                .education_bottom {
                    padding-top: 18px;
                    .education_college {
                        font-size: 24px;
                    }
                }
            }
        }
    }
    .job_info {
        padding-top: 58px;
        .job_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
                font-size: 34px;
                border-left: 6px solid #ee2e2e;
                padding-left: 10px;
                height: 36px;
                line-height: 32px;
            }
            img {
                width: 28px;
                height: 28px;
            }
        }
        .job_content {
            .job_item {
                padding-top: 54px;
                padding-left: 22px;
                .job_top {
                    display: flex;
                    justify-content: space-between;
                    .job_name {
                        color: #333333;
                        font-size: 26px;
                        font-weight: 600;
                    }
                    .job_time {
                        color: #b0b0b0;
                        font-size: 26px;
                    }
                }
                .job_bottom {
                     padding-top: 18px;
                    .job_position {
                        font-size: 26px;
                    }
                }
            }
        }
    }
    .project_info {
        padding-top: 58px;
        .project_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
                font-size: 34px;
                border-left: 6px solid #ee2e2e;
                padding-left: 10px;
                height: 36px;
                line-height: 32px;
            }
            img {
                width: 28px;
                height: 28px;
            }
        }
        .project_content {
            .project_item {
                padding-top: 54px;
                padding-left: 22px;
                .project_item_title {
                    .item_title_top {
                        display: flex;
                        justify-content: space-between;
                        .project_name {
                            color: #333333;
                            font-size: 26px;
                            font-weight: 600;
                        }
                        .project_time {
                            color: #b0b0b0;
                            font-size: 26px;
                        }
                    }
                    .item_title_bottom {
                        padding-top: 18px;
                        .project_role {
                            font-size: 26px;
                            color: #777777;
                        }
                    }
                }
                .project_workresult {
                    padding-top: 40px;
                    .workresult_text {
                        padding-right: 6px;
                        font-size: 26px;
                        color: #333333;
                        letter-spacing: 2px;
                    }
                    .workresult_image {
                        .img_item {
                            width: 100%;
                            margin: 0 auto;
                            display: flex;
                            flex-wrap: wrap;
                            column-count: 3;
                            column-gap: 50px;
                            img {
                                width: 180px;
                                height: 180px;
                                margin-top: 20px;
                            }
                        }
                    }
                }
            }
        }
    }
    .btn_group {
        padding: 40px 30px 0;
        display: flex;
        justify-content: space-between;
    }
}
.plcspan {
    font-size: 26px;
    color: #666666;
}
.dian {
    padding: 0 10px !important;
}
/deep/ .van-button {
    width: 300px;
    border-radius: 10px;
}
</style>